import { useState, useEffect } from 'react';
import { Cookie, X } from 'lucide-react';

const CookiePopup = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem('cookiesAccepted');
    if (!accepted) {
      setTimeout(() => setShow(true), 2000);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookiesAccepted', 'true');
    setShow(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookiesAccepted', 'minimal');
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:w-80 bg-white dark:bg-gray-800 rounded-xl shadow-2xl z-50 border border-gray-200 dark:border-gray-700 p-4">
      <div className="flex items-start gap-3 mb-3">
        <Cookie className="w-5 h-5 text-amber-500 flex-shrink-0 mt-0.5" />
        <div className="flex-1">
          <p className="text-sm text-gray-700 dark:text-gray-300">
            We use cookies to improve your experience.
          </p>
        </div>
        <button onClick={handleDecline} className="text-gray-400 hover:text-gray-600">
          <X className="w-4 h-4" />
        </button>
      </div>
      <div className="flex gap-2">
        <button
          onClick={handleDecline}
          className="flex-1 px-3 py-2 text-sm text-gray-600 dark:text-gray-400 font-medium border border-gray-200 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700"
        >
          Decline
        </button>
        <button
          onClick={handleAccept}
          className="flex-1 px-3 py-2 text-sm bg-green-600 text-white rounded-lg font-medium hover:bg-green-500"
        >
          Accept
        </button>
      </div>
    </div>
  );
};

export default CookiePopup;
